// Clients feature — query-key gyár + a lista-szűrő típusa. A tényleges hívásokat a route-ok a
// tipizált ts-rest kliensen (`api.clients.*`) intézik; a kulcsok itt élnek (cache-invalidálás + optimista
// írás egységesen). A `@atlas/contracts` a szerződés forrás-igazsága — itt csak kulcs/segéd-logika van.

/** A lista-lekérdezés szűrői (a query-kulcs része — szűrő-váltás új cache-bejegyzést nyit).
 *  A rendezés-KULCS fixen `name` (magyar collation, szerver-oldal) — csak az irány (`order`) váltható. */
export interface ClientListFilters {
  q: string;
  status: string;
  order: 'asc' | 'desc';
}

/** Query-kulcs gyár — a lista/detail cache egységes címzése (invalidálás + optimista update). */
export const clientKeys = {
  all: ['clients'] as const,
  lists: () => ['clients', 'list'] as const,
  list: (filters: ClientListFilters) => ['clients', 'list', filters] as const,
  detail: (id: string) => ['clients', 'detail', id] as const,
};
